module.exports = __webpack_public_path__ + "static/img/1.6a36f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/1.png
// module id = n3r0
// module chunks = 0